export type ContentTemplateType = 'MAGAZINE' | 'DONATION' | 'ENTRY';

export default class ContentTemplateDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  type: ContentTemplateType;
  markup: string;
}
